<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 290px;
  padding: 18px 0;
}

.instruction {
  display: flex;
  justify-content: space-between;

  .item-name {
    margin-bottom: 5px;
    color: #77CAD8;
    font-size: 14px;
  }

  .item-num {
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
  }
}

.bar {
  height: 250px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <div class="instruction">
        <div class="item" v-for="(item, index) in instructionData" :key="index">
          <div class="item-name">{{item.name}}</div>
          <div class="item-num">{{item.value}}</div>
        </div>
      </div>
      <div class="bar">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from "echarts";
import boxWrap from "components/dashboard/common/boxWrap";
export default {
  data() {
    return {
      timer: null,
      color: ["#AF69FF", "#00A0EA", "#13AF68", "#FFB52B", "#920784"],
      myChart: {},
      name: "可追溯覆盖率",
      data: [35.02, 9.5, 7.6, 2.4, 1.8, 12, 11.3, 8, 0.28, 4.51],
      instructionData: [
        { name: "追溯码赋码量", value: "11432083" },
        { name: "可追溯主体数", value: "498" },
        { name: "可追溯商品品种", value: "58" },
        { name: "三品一标可追溯覆盖率", value: "93%" }
      ]
    };
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData() {
      // for (var i = 0; i < 7; i++) {
      //   this.data[i] = this.data[i]
      //   // this.data[i] = Math.floor(Math.random() * 100);
      // }
      this.myChart = echarts.init(document.querySelector(".bar .main"));
      this.myChart.clear()
      this.chart();
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".bar .main"));
      this.myChart.setOption({
        animation: true,
        xAxis: {
          grid: {
            top: 0
          },
          data: [
            "百色芒果",
            "田东香芒",
            "百色番茄",
            "凌云牛心李",
            "德保山楂",
            "西林沙塘桔",
            "田阳香芒",
            "平果火龙果",
            "隆林板栗",
            "凌云白毫茶"
          ],
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            // alignWithLabel: true,
            color: "#fff",
            fontSize: 12,
            rotate: 30
          }
        },
        yAxis: {
          name: '百万',
          nameTextStyle: {
            color: "#fff",
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#fff",
            fontSize: 12
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0177d4"
            }
          }
        },
        series: [
          {
            type: "bar",
            barWidth: 18,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#C0E450"
                    },
                    {
                      offset: 0.8,
                      color: "#75CD2D"
                    }
                  ],
                  false
                )
              }
            },
            data: this.data
          }
        ]
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    var self = this;
    self.chart();
    self.init();
    this.timer = setInterval(() => {
      // 某些定时器操作
      self.getData()
    }, 3000);
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?766c9a94